
import OpenOtherApi from '@/api/OpenOtherApi';
import RoleSelect from '@/components/common/RoleSelect.vue';
import EweiTagsSelect from '@/components/common/EweiTagsSelect.vue';
import ServiceDeskSelect from '@/components/common/ServiceDeskSelect.vue';
import ServiceDeskTagSelect from '@/components/common/ServiceDeskTagSelect.vue';
import { RuleObject, useForm } from 'ant-design-vue/lib/form';
import { computed, createVNode, defineComponent, inject, onMounted, reactive, ref, watch } from 'vue';
import { isPositiveInteger } from '@/utils/tool.util';
import { message, Modal } from 'ant-design-vue';
import { ExclamationCircleOutlined } from '@ant-design/icons-vue';
import OpenEngineerApi from '@/api/OpenEngineerApi';
import OpenProviderApi from '@/api/OpenProviderApi';
import router from '@/router';
import { useRoute } from 'vue-router';
import { ProviderModule } from '@/store/modules/provider.module';

export default defineComponent({
  props: ['query'],
  components: {
    RoleSelect,
    EweiTagsSelect,
    ServiceDeskSelect,
    ServiceDeskTagSelect
  },
  setup (props) {
    const isLoading = ref(false)
    const hasPermission: any = inject('hasPermission')
    const engineer = reactive<any>({
      user: {
        name: '',
        email: '',
        emailExamined: true,
        mobilePhone: ''
      },
      nickname: '',
      role: { id: null },
      defaultServiceDesk: { id: null },
      serviceDesks: [],
      serviceDeskIds: [],
      minConcurrentChatNumber: '',
      maxConcurrentChatNumber: ''
    })
    const selectedTags = ref<any []>([])
    const sendEmailSuccess = ref(false)
    const currentRoleNameKey = computed(() => ProviderModule.engineer.role.nameKey) // 当前客服身份
    const filterRoleNameKey = computed(() => {
      if (engineer.role.nameKey === 'ROLE_NAME_CREATOR') {
        return []
      }
      if (
        currentRoleNameKey.value === 'ROLE_NAME_CREATOR' ||
        currentRoleNameKey.value === 'ROLE_NAME_ADMIN' ||
        engineer.role.nameKey === 'ROLE_NAME_ADMIN'
      ) {
        return ['ROLE_NAME_CREATOR']
      }
      return ['ROLE_NAME_CREATOR', 'ROLE_NAME_ADMIN']
    })
    const disabledRoleSelect = computed(() => {
      return engineer.isCreator || (
        currentRoleNameKey.value !== 'ROLE_NAME_CREATOR' &&
        currentRoleNameKey.value !== 'ROLE_NAME_ADMIN' &&
        engineer.role.nameKey === 'ROLE_NAME_ADMIN'
      )
    })
    const checkMinChatNumber = async (rule: RuleObject, value: string) => {
      if (!isPositiveInteger(value)) {
        return Promise.reject('下范围需大于0的正整数')
      }
      if (value > engineer.maxConcurrentChatNumber) {
        return Promise.reject('下范围需小于等于上范围')
      }
      return Promise.resolve()
    }
    const checkMaxChatNumber = async (rule: RuleObject, value: string) => {
      if (!isPositiveInteger(value)) {
        return Promise.reject('上范围需为大于0的正整数')
      }
      if (Number(value) > 9999) {
        return Promise.reject('上范围不能大于 9999')
      }
      if (engineer.minConcurrentChatNumber > value) {
        return Promise.reject('上范围需大于等于下范围')
      }
      return Promise.resolve()
    }
    const checkEmail = async (rule: RuleObject, value: string) => {
      if (!value && !engineer.user.mobilePhone) {
        return Promise.reject('客服邮箱和手机号不可同时为空')
      }
      return Promise.resolve()
    }
    const checkMobilePhone = async (rule: RuleObject, value: string) => {
      if (!value && !engineer.user.email) {
        return Promise.reject('客服邮箱和手机号不可同时为空')
      }
      return Promise.resolve()
    }
    const rules = reactive({
      'user.name': [
        { required: true, message: '请输入客服名', trigger: 'blur' }
      ],
      nickname: [
        { required: true, message: '请输入客服昵称', trigger: 'blur' }
      ],
      'user.email': [
        { required: true, message: '请输入客服邮箱', trigger: 'blur' }
      ],
      'role.id': [
        { required: true, message: '请选择客服角色', trigger: 'blur' }
      ],
      serviceDeskIds: [
        { required: true, message: '请选择所属客服组', trigger: 'blur' }
      ],
      'defaultServiceDesk.id': [
        { required: true, message: '请选择首选客服组', trigger: 'blur' }
      ],
      minConcurrentChatNumber: [
        { validator: checkMinChatNumber, trigger: 'blur' }
      ],
      maxConcurrentChatNumber: [
        { validator: checkMaxChatNumber, trigger: 'blur' }
      ]
    })

    const { validate, validateInfos } = useForm(engineer, rules);

    function loadDetail (id) {
      if (!id) return
      OpenOtherApi.getEngineerInfo(id).then(res => {
        res.serviceDeskIds = res?.serviceDesks?.map(item => item.id)
        res.serviceDeskNames = res?.serviceDesks?.map(item => item.name).join(",")
        Object.assign(engineer, res)
      })
    }
    // 向日葵服务
    const hadSunloginWeb = ref<boolean>(false)
    function getProviderLicense () {
      OpenProviderApi.getProviderLicense().then(res => {
        hadSunloginWeb.value = res.moduleList && res.moduleList.includes('sunlogin_web')
        console.log('hadSunloginWeb', hadSunloginWeb.value)
      })
    }

    onMounted(() => {
      const { id: pId } = props.query // 父级传来的
      const { id: uId } = useRoute().query // 路由携带的
      loadDetail(pId || uId)
      getProviderLicense()
    })

    function handleSubmit () {
      validate().then(() => {
        isLoading.value = true
        const engineerData = JSON.parse(JSON.stringify(engineer))
        engineerData.serviceDesks = engineerData.serviceDeskIds.map(id => ({ id }))
        if (engineerData.id > 0) {
          if (!hasPermission.value('engieer_update')) {
            message.error('暂无权限，请联系管理员。')
            return
          }
          OpenOtherApi.updateEngineer({
            engineer: engineerData
          }).then(() => {
            isLoading.value = false
            message.success('更新成功');
            router.push({
              path: '/system_setting/account-manage'
            })
          }).catch(() => {
            isLoading.value = false
          })
        } else {
          if (!hasPermission.value('engieer_create')) {
            message.error('暂无权限，请联系管理员。')
            return
          }
          engineerData.user.nickname = engineerData.nickname
          engineerData.user.tags = selectedTags.value
          OpenOtherApi.saveEngineer(engineerData).then(res => {
            if (res && res.id > 0) {
              isLoading.value = false
              message.success('创建成功')
              router.replace({
                path: '/system_setting/account-manage'
              })
            }
          }).catch(() => {
            isLoading.value = false
          })
        }
      })
    }

    function checkDefaultServiceDesk (serviceDesks: Array<any>) {
      const index = serviceDesks.findIndex(item => item === engineer.defaultServiceDesk.id)
      if (index === -1) {
        engineer.defaultServiceDesk.id = null
      }
    }

    function handleEnable (isEnable) {
      if (!hasPermission.value('engieer_update')) {
        message.error('暂无权限，请联系管理员。')
        return
      }
      Modal.confirm({
        title: () => '确认要' + (isEnable ? '启用' : '停用') + '该客服吗？',
        icon: () => createVNode(ExclamationCircleOutlined),
        okText: '确定',
        cancelText: '取消',
        onOk () {
          OpenEngineerApi.batchEnable({
            engineerIds: [engineer.id],
            enabled: isEnable
          }).then(() => {
            message.success(isEnable ? '已启用' : '已停用')
            engineer.user.status = isEnable ? 1 : 0
          })
        }
      })
    }

    function handleSendEmailAgain () {
      Modal.confirm({
        title: () => '重发注册邮件',
        content: () => '发送邮件至' + engineer.user.email,
        okText: '确定',
        cancelText: '取消',
        onOk () {
          OpenOtherApi.sendResetPasswordEmail({ email: engineer.user.email })
            .then(res => {
              if (res === 'mail_sent') {
                sendEmailSuccess.value = true
                message.success('邮件发送成功！')
              }
              if (res === "user_not_found" || res === "email_is_null") {
                message.error('当前客服账号不存在或者已激活')
              }
            }).catch(() => {
              message.error('邮件发送失败！')
            })
        }
      })
    }

    function handleDeleteEngineer () {
      if (!hasPermission.value('engieer_delete')) {
        message.error('暂无权限，请联系管理员。')
        return
      }
      Modal.confirm({
        title: () => '确认要删除该客服吗？',
        icon: () => createVNode(ExclamationCircleOutlined),
        okText: '确定',
        cancelText: '取消',
        onOk () {
          OpenEngineerApi.deleteEngineers({ ids: engineer.id })
            .then(() => {
              message.success('已删除')
              router.replace({
                path: '/system_setting/account-manage'
              })
            })
        }
      })
    }

    function handleTagChange (tags) {
      selectedTags.value = tags.map(tag => ({ id: tag.value }))
    }

    function handleModifyAccount () {
      window.open('https://console.sunlogin.oray.com/account-system/account')
    }

    return {
      isLoading,
      hasPermission,
      engineer,
      disabledRoleSelect,
      sendEmailSuccess,
      filterRoleNameKey,
      rules,
      validateInfos,
      handleSubmit,
      checkDefaultServiceDesk,
      handleEnable,
      handleSendEmailAgain,
      handleDeleteEngineer,
      handleTagChange,
      hadSunloginWeb,
      handleModifyAccount
    }
  }
})
